import { accountsTypesForOperations, accountsFamiliesForOperations, accountsCurrenciesOperation } from '@/assets/scripts/mappers/accounts'
import { routeList } from '@/router/helpers/routes'

/* Filters accounts for a specific feature
@accountsList { array } - list of accounts
@returns { array } - returns accounts available for this route feature
*/
export const parseAccountsForFeature = (accountsList) => {
    const currentRoutePath = window.location.hash.replace('#', '').split('?')[0]
    const routePathKey = Object.keys(routeList).find(key => routeList[key] === currentRoutePath)
    const mapperRoute = routePathKey.replace('_PATH', '')

    /* We first checking if there's no accounts, if not, we simply return the empty array we just received */
    if (!accountsList?.length) return []

    let allAccounts = accountsList

    /* Validate if there's a filter by type for this operation, if so we filter the array */
    if (accountsTypesForOperations[mapperRoute]) {
        const allowedTypes = accountsTypesForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedTypes.find(type => { return type === (account.accountType || account.type) }) })
    }

    /* Validate if there's a filter by currency for this operation, if so we filter the array */
    if (accountsFamiliesForOperations[mapperRoute]) {
        const allowedFamilies = accountsFamiliesForOperations[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedFamilies.find(family => { return family === account.accountFamily }) })
    }

    /* Validate if there's a filter by currency for this operation, if so we filter the array */
    if (accountsCurrenciesOperation[mapperRoute]) {
        const allowedCurrencies = accountsCurrenciesOperation[mapperRoute]
        allAccounts = allAccounts.filter(account => { return allowedCurrencies.find(currency => { return currency === account.currency }) })
    }
    /* Next we will validate if filter removed the default account from our array of accounts if so, we will define a new one */
    if (allAccounts.length && !allAccounts.find((obj) => obj.default)) {
        allAccounts[0].default = true
    }

    return allAccounts
}
